<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar  :click-not-close='clickNotClose' :position-right='positionRight' :position-left='!positionRight'  parent="body" default-index="1" color="primary"
    class=" items-no-padding" spacer v-model="isSidebarActiveLocal" :class="{'v-nav-menu':!position,'add-new-data-sidebar':position,'leftDataSidebar':!positionRight}">
    <div class="flex items-center justify-between" :class='{"mt-6 px-6":position}'>
      <h4 v-if='position'>{{title}}</h4>
      <div v-else class="header-sidebar flex items-end justify-between">
        <router-link tag="div" class="cursor-pointer flex items-center" to="/">
          <img src='@/assets/images/pages/landing/logo-hopesen1.png' height="40px" alt="logo" class="">
        </router-link>
      </div>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0" :class='positionRight?"rightSidebar":"leftSidebar"'></vs-divider>
    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
      <div class="bg-white" :class='{"p-6":position,"pt-2":!position}'>
        <slot name='content'></slot>
      </div>
    </VuePerfectScrollbar>

    <div v-if='position && positionRight' class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button v-if='trust!=0' @click="submitData" :disabled="!formValid">{{submitText}}</vs-button>
      <vs-button class="ml-3" v-if='(type===0||type===2) && trust!=0' type="border" color="danger" @click="deleteData">{{$t('delete')}}</vs-button>
      <vs-button class='ml-3' type="flat" color="rgb(182, 185, 183)" @click="isSidebarActiveLocal = false">{{$t('cancel')}}</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  export default {
    name:'DataViewSidebar',
    props: {
      isSidebarActive: {
        type: Boolean,
        required: true
      },
      submitText: {
        type: String,
        default: 'submit'
      },
      formValid:{
        type: Boolean,
        default: true
      },
      title:{
        type: String,
        default: ''
      },
      type:{
        type: Number,
        default: 1
      },
      trust:{
        type: Number,
        default: 1
      },
      position:{
        type: Boolean,
        default: true
      },
      positionRight:{
        type: Boolean,
        default: true
      },
      clickNotClose:{
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
        },
      }
    },
    computed: {
      isSidebarActiveLocal: {
        get() {
          return this.isSidebarActive
        },
        set(val) {
          if (!val) {
            this.$emit('closeSidebar')
          }
        }
      }
    },
    methods: {
      submitData() {
        this.$validator.validateAll().then(() => {
          this.$emit('submitData')
        })
      },
      deleteData(){
        this.$emit('delete')
      }
    },
    components: {
      VuePerfectScrollbar
    }
  }

</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 61000;    
    }
    ::v-deep .vs-sidebar {
      z-index: 63000;
      width: 450px;
      max-width: 90vw;
    }
    &.leftDataSidebar {
      ::v-deep .vs-sidebar--background {
        display: none;   
      }
      ::v-deep .vs-sidebar{      
        width: 200px;
        max-width: 300px;
        background: transparent;
        .ps-container{
          background: #fff;
        }
      }
    }
  }

  .scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
  }
</style>
